module.exports = __webpack_public_path__ + "static/media/daily discipline report.03e6f010.svg";